export const THEMES = {
  original: {
    id: 'original',
    name: 'Karry Original',
    description: 'El tema original de la tienda',
    preview: 'linear-gradient(135deg, #09090b 0%, #18181b 50%, #fbbf24 100%)',
    colors: {
      bg: '#09090b',
      surface: 'rgba(255,255,255,0.05)',
      border: 'rgba(255,255,255,0.05)',
      accent: '#fbbf24',
      accentHover: '#fcd34d',
      text: '#ffffff',
      textMuted: '#a1a1aa',
      navBg: 'rgba(9,9,11,0.8)',
      badge: '#fbbf24',
      badgeText: '#09090b',
    },
    hero: { tagline: 'Calidad Artesanal Mexicana', title1: 'DENIM', title2: 'PREMIUM', subtitle: 'Pantalones de mezclilla hechos a mano con los mejores materiales', cta: 'Ver Catalogo', gradient: 'radial-gradient(circle at 30% 50%, rgba(251,191,36,0.15) 0%, transparent 50%), radial-gradient(circle at 70% 30%, rgba(251,191,36,0.08) 0%, transparent 50%)' },
    font: "system-ui, -apple-system, sans-serif",
    buttonRadius: '9999px',
    cardRadius: '16px',
  },
  denim_premium: {
    id: 'denim_premium',
    name: 'Denim Premium',
    description: 'Elegancia en mezclilla, estilo Levi\'s',
    preview: 'linear-gradient(135deg, #0c1220 0%, #1a1a2e 50%, #d4a853 100%)',
    colors: {
      bg: '#0a0f1a',
      surface: 'rgba(255,255,255,0.04)',
      border: 'rgba(255,255,255,0.06)',
      accent: '#d4a853',
      accentHover: '#e4be6a',
      text: '#f5f5f5',
      textMuted: '#8b95a5',
      navBg: 'rgba(10,15,26,0.85)',
      badge: '#d4a853',
      badgeText: '#0a0f1a',
    },
    hero: { tagline: 'Calidad Artesanal Mexicana', title1: 'DENIM', title2: 'PREMIUM', subtitle: 'Pantalones de mezclilla hechos a mano con los mejores materiales', cta: 'Explorar Coleccion', gradient: 'radial-gradient(ellipse at 30% 50%, rgba(212,168,83,0.12) 0%, transparent 60%)' },
    font: "'Playfair Display', serif",
    buttonRadius: '9999px',
    cardRadius: '16px',
  },
  streetwear_dark: {
    id: 'streetwear_dark',
    name: 'Streetwear Dark',
    description: 'Urbano, moderno, bold',
    preview: 'linear-gradient(135deg, #000 0%, #1a1a1a 50%, #ff3b30 100%)',
    colors: {
      bg: '#000000',
      surface: 'rgba(255,255,255,0.06)',
      border: 'rgba(255,255,255,0.08)',
      accent: '#ff3b30',
      accentHover: '#ff5e55',
      text: '#ffffff',
      textMuted: '#888888',
      navBg: 'rgba(0,0,0,0.9)',
      badge: '#ff3b30',
      badgeText: '#ffffff',
    },
    hero: { tagline: 'NUEVA TEMPORADA', title1: 'STREET', title2: 'CULTURE', subtitle: 'Moda urbana sin limites', cta: 'COMPRAR AHORA', gradient: 'radial-gradient(ellipse at 70% 30%, rgba(255,59,48,0.15) 0%, transparent 60%)' },
    font: "'Bebas Neue', sans-serif",
    buttonRadius: '4px',
    cardRadius: '8px',
  },
  summer_fashion: {
    id: 'summer_fashion',
    name: 'Summer Fashion',
    description: 'Fresco, vibrante, tropical',
    preview: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #38bdf8 100%)',
    colors: {
      bg: '#0f172a',
      surface: 'rgba(56,189,248,0.06)',
      border: 'rgba(56,189,248,0.1)',
      accent: '#38bdf8',
      accentHover: '#7dd3fc',
      text: '#f0f9ff',
      textMuted: '#94a3b8',
      navBg: 'rgba(15,23,42,0.85)',
      badge: '#38bdf8',
      badgeText: '#0f172a',
    },
    hero: { tagline: 'COLECCION VERANO', title1: 'SUMMER', title2: 'VIBES', subtitle: 'Prendas frescas para los dias calurosos', cta: 'Ver Lo Nuevo', gradient: 'radial-gradient(ellipse at 50% 40%, rgba(56,189,248,0.1) 0%, transparent 60%)' },
    font: "'Poppins', sans-serif",
    buttonRadius: '12px',
    cardRadius: '20px',
  },
  minimal_luxury: {
    id: 'minimal_luxury',
    name: 'Minimal Luxury',
    description: 'Minimalismo premium estilo Zara',
    preview: 'linear-gradient(135deg, #fafafa 0%, #e5e5e5 50%, #171717 100%)',
    colors: {
      bg: '#fafafa',
      surface: 'rgba(0,0,0,0.03)',
      border: 'rgba(0,0,0,0.08)',
      accent: '#171717',
      accentHover: '#404040',
      text: '#171717',
      textMuted: '#737373',
      navBg: 'rgba(250,250,250,0.9)',
      badge: '#171717',
      badgeText: '#fafafa',
    },
    hero: { tagline: 'NEW ARRIVALS', title1: 'ESSENTIAL', title2: 'COLLECTION', subtitle: 'Piezas atemporales para el guardarropa moderno', cta: 'Descubrir', gradient: 'none' },
    font: "'DM Sans', sans-serif",
    buttonRadius: '0px',
    cardRadius: '0px',
  },
  vintage_blue: {
    id: 'vintage_blue',
    name: 'Vintage Blue',
    description: 'Retro denim, nostalgia americana',
    preview: 'linear-gradient(135deg, #1e293b 0%, #1e3a5f 50%, #c2956b 100%)',
    colors: {
      bg: '#14202e',
      surface: 'rgba(194,149,107,0.06)',
      border: 'rgba(194,149,107,0.12)',
      accent: '#c2956b',
      accentHover: '#d4ad85',
      text: '#e8ddd0',
      textMuted: '#8899aa',
      navBg: 'rgba(20,32,46,0.9)',
      badge: '#c2956b',
      badgeText: '#14202e',
    },
    hero: { tagline: 'ESTILO CLASICO', title1: 'VINTAGE', title2: 'HERITAGE', subtitle: 'El denim que nunca pasa de moda', cta: 'Ver Clasicos', gradient: 'radial-gradient(ellipse at 40% 50%, rgba(194,149,107,0.1) 0%, transparent 60%)' },
    font: "'Libre Baskerville', serif",
    buttonRadius: '6px',
    cardRadius: '12px',
  },
  formal_casual: {
    id: 'formal_casual',
    name: 'Formal Casual',
    description: 'Elegancia relajada para camisas',
    preview: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #e2e8f0 100%)',
    colors: {
      bg: '#111827',
      surface: 'rgba(226,232,240,0.05)',
      border: 'rgba(226,232,240,0.08)',
      accent: '#e2e8f0',
      accentHover: '#f1f5f9',
      text: '#f8fafc',
      textMuted: '#9ca3af',
      navBg: 'rgba(17,24,39,0.9)',
      badge: '#e2e8f0',
      badgeText: '#111827',
    },
    hero: { tagline: 'CAMISAS & MAS', title1: 'SMART', title2: 'CASUAL', subtitle: 'Del trabajo a la calle con estilo', cta: 'Ver Camisas', gradient: 'radial-gradient(ellipse at 60% 40%, rgba(226,232,240,0.06) 0%, transparent 60%)' },
    font: "'Inter', sans-serif",
    buttonRadius: '8px',
    cardRadius: '12px',
  },
  new_drop: {
    id: 'new_drop',
    name: 'New Drop Hero',
    description: 'Lanzamiento impactante',
    preview: 'linear-gradient(135deg, #0a0a0a 0%, #1a0a2e 50%, #a855f7 100%)',
    colors: {
      bg: '#0a0a0a',
      surface: 'rgba(168,85,247,0.06)',
      border: 'rgba(168,85,247,0.12)',
      accent: '#a855f7',
      accentHover: '#c084fc',
      text: '#faf5ff',
      textMuted: '#a78bfa',
      navBg: 'rgba(10,10,10,0.9)',
      badge: '#a855f7',
      badgeText: '#ffffff',
    },
    hero: { tagline: 'JUST DROPPED', title1: 'NEW', title2: 'DROP', subtitle: 'Piezas exclusivas en edicion limitada', cta: 'COMPRAR YA', gradient: 'radial-gradient(ellipse at 50% 50%, rgba(168,85,247,0.15) 0%, transparent 60%)' },
    font: "'Space Grotesk', sans-serif",
    buttonRadius: '9999px',
    cardRadius: '16px',
  },
  black_friday: {
    id: 'black_friday',
    name: 'Black Friday',
    description: 'Modo descuentos agresivo',
    preview: 'linear-gradient(135deg, #000 0%, #1a0000 50%, #ef4444 100%)',
    colors: {
      bg: '#000000',
      surface: 'rgba(239,68,68,0.06)',
      border: 'rgba(239,68,68,0.12)',
      accent: '#ef4444',
      accentHover: '#f87171',
      text: '#ffffff',
      textMuted: '#fca5a5',
      navBg: 'rgba(0,0,0,0.95)',
      badge: '#ef4444',
      badgeText: '#ffffff',
    },
    hero: { tagline: 'OFERTA ESPECIAL', title1: 'BLACK', title2: 'FRIDAY', subtitle: 'Hasta 70% de descuento en toda la tienda', cta: 'VER OFERTAS', gradient: 'radial-gradient(ellipse at 50% 50%, rgba(239,68,68,0.12) 0%, transparent 60%)' },
    font: "'Bebas Neue', sans-serif",
    buttonRadius: '4px',
    cardRadius: '8px',
  },
  seasonal_looks: {
    id: 'seasonal_looks',
    name: 'Seasonal Looks',
    description: 'Outfits de temporada completos',
    preview: 'linear-gradient(135deg, #1a1a1a 0%, #2d1f0e 50%, #d97706 100%)',
    colors: {
      bg: '#0f0d0a',
      surface: 'rgba(217,119,6,0.06)',
      border: 'rgba(217,119,6,0.1)',
      accent: '#d97706',
      accentHover: '#f59e0b',
      text: '#fef3c7',
      textMuted: '#92806b',
      navBg: 'rgba(15,13,10,0.9)',
      badge: '#d97706',
      badgeText: '#0f0d0a',
    },
    hero: { tagline: 'TEMPORADA OTONO', title1: 'AUTUMN', title2: 'COLLECTION', subtitle: 'Outfits completos para la nueva temporada', cta: 'Ver Looks', gradient: 'radial-gradient(ellipse at 40% 60%, rgba(217,119,6,0.1) 0%, transparent 60%)' },
    font: "'Cormorant Garamond', serif",
    buttonRadius: '9999px',
    cardRadius: '20px',
  },
  shirts_collection: {
    id: 'shirts_collection',
    name: 'Shirts Collection',
    description: 'Enfocado en camisas, estilo H&M',
    preview: 'linear-gradient(135deg, #18181b 0%, #1f2937 50%, #6ee7b7 100%)',
    colors: {
      bg: '#111113',
      surface: 'rgba(110,231,183,0.04)',
      border: 'rgba(110,231,183,0.08)',
      accent: '#6ee7b7',
      accentHover: '#a7f3d0',
      text: '#ecfdf5',
      textMuted: '#86efac',
      navBg: 'rgba(17,17,19,0.9)',
      badge: '#6ee7b7',
      badgeText: '#111113',
    },
    hero: { tagline: 'NUEVA COLECCION', title1: 'SHIRTS', title2: 'ESSENTIALS', subtitle: 'Camisas para cada ocasion', cta: 'Explorar', gradient: 'radial-gradient(ellipse at 60% 40%, rgba(110,231,183,0.08) 0%, transparent 60%)' },
    font: "'DM Sans', sans-serif",
    buttonRadius: '8px',
    cardRadius: '14px',
  },
};

export const THEME_LIST = Object.values(THEMES);
export const getTheme = (id) => THEMES[id] || THEMES.original;
